export const INITIALIZED = 0
export const LOADING = 1
export const READY = 1